import { assert } from '@/core'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'


export class IdentityCodesService extends BaseService {

  static get entity() {
    return 'identity-codes'; // Update to reflect correct entity for the time slots
  }

  /**
   * Sync QR codes with the backend
   * @param {string} kioskId - The kiosk ID to be sent in the request body
   */
  static async syncQRCodes(kioskId, appointmentCode = '') {
    assert.string(kioskId, { required: true }); // Ensure the kioskId is a valid string
    assert.string(appointmentCode, { required: false }); // Ensure the kioskId is a valid string

    try {
      // Construct the request body
      const body = {
        kioskId, // Send the kiosk ID in the body
        appointmentCode
      };

      // Send the POST request to sync QR codes
      const response = await this.request({ auth: true }).post('/sync/qrcodes', body);

      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error?.response?.data?.error || error?.response?.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

    /**
   * Poll QR code status from backend
   * @param {string} qrcodeId - The QR code ID (e.g., "6580-8484")
   */
  static async pollQRStatus(qrcodeId) {
    assert.string(qrcodeId, { required: true });

    try {
      const response = await this.request({ auth: true }).get(`/sync/polling/qrcodes/${qrcodeId}`);

      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error?.response?.data?.error || error?.response?.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
